import { defaultPathByView } from '@ps/web-spade-embedded-api';
import type { z } from 'zod/v4-mini';

import { type BaseLoadFields, type InitSchema, type LoadSchema } from '../sdk-types';

import { resolveThemeVariant } from './resolveThemeVariant';

export function getIframeUrl({
  locale,
  view,
  path,
  themeVariant
}: {
  locale: InitSchema['locale'];
  view: LoadSchema['view'];
  path: LoadSchema['path'];
  themeVariant?: z.infer<(typeof BaseLoadFields)['themeVariant']>;
}): string {
  const spadePath = `spade/${view}/${locale}/${path ? path : defaultPathByView[view]}`;
  const baseUrl = `${window.location.origin}/${spadePath}`;
  const resolved = resolveThemeVariant(themeVariant);

  return `${baseUrl}?themeVariant=${encodeURIComponent(resolved)}`;
}
